import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useLocalUser } from './useLocalUser';

export function useAuth() {
  const { userId: localUserId } = useLocalUser();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userId, setUserId] = useState<string>(localUserId);

  useEffect(() => {
    // Check initial auth state
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        setIsAuthenticated(true);
        setUserId(session.user.id);
      }
    };
    checkAuth();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        setIsAuthenticated(true);
        setUserId(session.user.id);
      } else {
        setIsAuthenticated(false);
        setUserId(localUserId);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [localUserId]);

  return {
    userId,
    isAuthenticated
  };
}